import { render } from "./MinBarChart.vue?vue&type=template&id=202c4dd5&scoped=true"
import script from "./MinBarChart.vue?vue&type=script&lang=js"
export * from "./MinBarChart.vue?vue&type=script&lang=js"

import "./MinBarChart.vue?vue&type=style&index=0&id=202c4dd5&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/sparta-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-202c4dd5"]])

export default __exports__